import * as _ from 'underscore';
import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { IDataSourceBase } from '../models/IDataSourceInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { DataSources } from '../resources/Datasources';
import { IResult } from '../ServerApi/types/IResponse';
import { ActionHelpers } from './ActionHelpers';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { DataSourceErrors } from './DataSourceErrors';
import { ModalService } from './ModalService';

export interface IDeleteDatasourcesActionResult {
  allowed: boolean;
  serverResult?: IResult;
}

export class DeleteDatasourcesAction {

  public static $inject = ['DataSourceErrors', 'ActionHelpers', 'ConfirmActionDialog', '$translate', 'DataSources', 'ModalService'];

  constructor(
    private DataSourceErrors: DataSourceErrors,
    private ActionHelpers: ActionHelpers,
    private ConfirmActionDialog: ConfirmActionDialog,
    private $translate: ng.translate.ITranslateService,
    private DataSources: DataSources,
    private ModalService: ModalService) { }

  public confirmDeleteDatasource(datasource: IDataSourceBase, context: IActionContext): ng.IPromise<IDeleteDatasourcesActionResult> {
    return this.confirmDeleteDatasources(Set.singleton(datasource, (ds: IDataSourceBase) => ds.id), context);
  }

  public confirmDeleteDatasources(datasources: Set<IDataSourceBase>, context: IActionContext): ng.IPromise<IDeleteDatasourcesActionResult> {

    // Disallow delete if all selected datasources are embedded.
    if (datasources.all((ds: IDataSourceBase) => _.isObject(ds.workbook))) {
      return this.ModalService.alert({
        titleId: 'deleteDatasources_cannotDeleteAlertTitle',
        messageId: 'deleteDatasources_cannotDeleteAlertMessage'
      }).result.then(() => {
          return {
            allowed: false
          };
        });
    }

    const dialogBody = datasources.size() === 1
      ? this.$translate.instant('confirmDeleteDatasource', { DATASOURCE_NAME: L10n.elideIfLong(datasources.first().name) })
      : this.$translate.instant('confirmDeleteDatasources', { DATASOURCE_COUNT: datasources.size() }, L10n.Interpolations.Count);

    return this.ConfirmActionDialog.open({
      scope: context.scope,
      title: this.$translate.instant('deleteMessage'),
      bodyText: dialogBody,
      actionName: this.$translate.instant('confirmDeleteButton', {
        ITEM_COUNT: datasources.size()
      }, L10n.Interpolations.Count),
      isDeleteAction: true,

      action: (dialogInstance: IConfirmActionDialogInstance) => {
        return this.DataSources.del(datasources.keys()).then(
          (result: IResult) => this.notifyResult(datasources, result));
      }
    }).result.then((serverResult: IResult) => {
        return {
          allowed: true,
          serverResult: serverResult
        };
      });
  }

  private notifyResult(datasources: Set<IDataSourceBase>, result: IResult) {
    this.ActionHelpers.notifyStandardError(
      datasources,
      {
        successId: 'deleteDatasourcesSuccess',
        errorId: 'deleteDatasourcesError'
      },
      (errorItem: IErrorItem<IDataSourceBase>) => this.DataSourceErrors.errorDetailsFor(errorItem))(result);
  }

}

Module.instance().service('DeleteDatasourcesAction', DeleteDatasourcesAction);
